import PropTypes from "prop-types"
import React from "react"

import ComponentChangeEdition from "../change-edition"

const Overview = ({ blockOverview, blockLastUpdated, type }) => (
  <div className="col col-12 bg-mercer-blue-light fg-mercer-blue-mid p2 md-py2 md-px3 mb2 relative">
    <div className="center mb2 relative">
      <div className="md-absolute" style={{bottom: 0}}>
        <small className="">{blockLastUpdated.title} {blockLastUpdated.content}</small>
      </div>
      <h1 className="mt0 mb0">{blockOverview.title}</h1>
      <div className="md-absolute" style={{right: 0, bottom:0}}>
        <ComponentChangeEdition type={type} />
      </div>
    </div>
    <div className="col col-12 center">
        <p style={{ fontWeight: 400, }}>{blockOverview.content}</p>
    </div>
    <div className="col col-12 mt2 center">
      <a href={blockOverview.link1} target="_parent" className="btn btn-primary bg-mercer-yellow-mid black">Download Quarterly Report</a>
    </div>
  </div>
)

Overview.propTypes = {
  blockOverview: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    link1: PropTypes.string,
  }),
}

Overview.defaultProps = {
  blockOverview: {
    title: ``,
    content: ``,
    link1: ``,
  },
}

export default Overview
